import React, { type FC } from 'react'
import { FormHelperText } from '@mui/material'

interface RequiredFieldHelperTextProps {
  isEmpty: boolean
  children: React.ReactNode
}

const RequiredFieldHelperText: FC<RequiredFieldHelperTextProps> = ({ isEmpty, children }) => {
  return isEmpty ? <FormHelperText>{children}</FormHelperText> : null
}

export default RequiredFieldHelperText
